__turbopack_context__.v({
  "backLink": "cookie-policy-page-module__rpreHW__backLink",
  "brand": "cookie-policy-page-module__rpreHW__brand",
  "browserList": "cookie-policy-page-module__rpreHW__browserList",
  "header": "cookie-policy-page-module__rpreHW__header",
  "languages": "cookie-policy-page-module__rpreHW__languages",
  "note": "cookie-policy-page-module__rpreHW__note",
  "page": "cookie-policy-page-module__rpreHW__page",
  "policy": "cookie-policy-page-module__rpreHW__policy",
  "precedence": "cookie-policy-page-module__rpreHW__precedence",
  "section": "cookie-policy-page-module__rpreHW__section",
  "subsection": "cookie-policy-page-module__rpreHW__subsection",
  "tableWrap": "cookie-policy-page-module__rpreHW__tableWrap",
  "titleBlock": "cookie-policy-page-module__rpreHW__titleBlock",
});
